export const PRIMARY_COLOR = '#3384ff';
